export const scrollDetector = (idToShow, idConstraint) => {
  if (!idToShow || !idConstraint) {
    return;
  }
  window.addEventListener("scroll", function() {
    const elementToShow = document.getElementById(`${idToShow}`);
    const elementConstraint = document.getElementsByClassName(
      `${idConstraint}`
    )[0];
    const offsetTop = elementConstraint ? elementConstraint.offsetTop : 0;
    if (elementToShow && elementConstraint) {
      if (window.pageYOffset > offsetTop) {
        elementToShow.style.display = "flex";
      } else {
        elementToShow.style.display = "none";
      }
    }
  });
};
